var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetAddressBookAction, ResetAddressBookAction, SetAddressBookParamsAction } from '../address-book.actions';
import { getWholeAddressBookSelector } from '../address-book.reducer';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
var AddressBookListComponent = /** @class */ (function () {
    function AddressBookListComponent(route, store, location) {
        this.route = route;
        this.store = store;
        this.location = location;
        this.displayedColumns = [
            'contactName',
            'contactSurname',
            'msisdn',
            'contactEmail',
            'companyName',
            'contactDetails'
        ];
        this.pageSizeOptions = [10, 20, 100];
        this.keepFilters = false;
        this.phraseControl = new FormControl('');
    }
    AddressBookListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.keepFilters = this.route.snapshot.queryParamMap.get('keepFilters') === 'true';
        this.msisdns = this.route.snapshot.data['msisdns'];
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.data = this.route.snapshot.data['addressBook'];
        this.store.select(getWholeAddressBookSelector).subscribe(function (state) {
            var addressBook = state.addressBook, params = state.params;
            _this.filters = __assign({}, params);
            _this.updateSearchPhrase();
            _this.updateDataSource(addressBook);
            _this.updatePaginator(addressBook, params);
        });
        this.setupInitialData();
        this.changeDataOnSearchPhraseChanges();
    };
    AddressBookListComponent.prototype.ngOnDestroy = function () {
        if (!this.keepFilters) {
            this.store.dispatch(new ResetAddressBookAction());
        }
        if (this.phraseControlSubscription) {
            this.phraseControlSubscription.unsubscribe();
        }
    };
    AddressBookListComponent.prototype.addFilter = function (type, value) {
        this.filters[type] = value;
        this.resetPager();
        this.store.dispatch(new SetAddressBookParamsAction(this.filters));
    };
    AddressBookListComponent.prototype.changePage = function (event) {
        this.filters.pager = {
            limit: event.pageSize,
            page: event.pageIndex
        };
        this.store.dispatch(new SetAddressBookParamsAction(this.filters));
    };
    AddressBookListComponent.prototype.sortChange = function (_a) {
        var active = _a.active, direction = _a.direction;
        this.filters.order = direction.toUpperCase() || null;
        this.filters.sortBy = active;
        this.resetPager();
        this.store.dispatch(new SetAddressBookParamsAction(this.filters));
    };
    AddressBookListComponent.prototype.getNumbersCountry = function (number) {
        if (!number) {
            return '';
        }
        var parsed = parsePhoneNumberFromString(number.toString());
        return (parsed && parsed.country) || '';
    };
    AddressBookListComponent.prototype.formatNumbers = function (numbers) {
        return numbers
            .slice(1)
            .join()
            .replaceAll(',', '\n');
    };
    AddressBookListComponent.prototype.toggleContactsWithEmptyNameSearch = function (event) {
        this.filters.showContactsWithEmptyName = event.checked;
        this.store.dispatch(new SetAddressBookParamsAction(this.filters));
    };
    AddressBookListComponent.prototype.updatePaginator = function (addressBook, params) {
        this.paginator.length = addressBook.total;
        if (params && params.pager) {
            var _a = params.pager, limit = _a.limit, page = _a.page;
            this.paginator.pageIndex = page;
            this.paginator.pageSize = limit;
        }
    };
    AddressBookListComponent.prototype.setupInitialData = function () {
        if (this.keepFilters) {
            this.keepFilters = false;
        }
        else {
            this.store.dispatch(new GetAddressBookAction(this.filters));
        }
    };
    AddressBookListComponent.prototype.changeDataOnSearchPhraseChanges = function () {
        var _this = this;
        this.phraseControlSubscription = this.phraseControl.valueChanges
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe(function (phrase) {
            _this.addFilter('phrase', phrase);
        });
    };
    AddressBookListComponent.prototype.updateSearchPhrase = function () {
        var isInitialRender = !this.phraseControl.value;
        if (isInitialRender) {
            this.phraseControl.setValue(this.filters.phrase);
        }
        else {
            // We don't need to sync input, because value from form control is always up to date.
        }
    };
    AddressBookListComponent.prototype.updateDataSource = function (addressBook) {
        this.dataSource.data = addressBook.data.map(function (item) { return (__assign({}, item, { msisdn: item.msisdns[0] })); });
    };
    AddressBookListComponent.prototype.resetPager = function () {
        this.filters.pager.page = 0;
    };
    AddressBookListComponent.prototype.contactDetailsClicked = function () {
        this.location.replaceState('/address-book?keepFilters=true');
        this.keepFilters = true;
    };
    return AddressBookListComponent;
}());
export { AddressBookListComponent };
